import { SelectType } from '~/pages/PdvOnline/types';

export const tipoPessoa: SelectType[] = [
  { value: 0, label: 'Física' },
  { value: 1, label: 'Jurídica' },
];
